import React, { useContext, useEffect } from 'react';
import { DropdownItem } from 'reactstrap';
import _remove from 'lodash/remove';
import SearchWithDropdownContext from '../SearchWithDropdownContext';

export default ({ value, label, selectOthers = undefined }) => {
  const { onChange, allOptions, inputValue, setSelectedOptions, setAllOptions } = useContext(SearchWithDropdownContext);

  useEffect(() => {
    if (!selectOthers) {
      setAllOptions((actualAllOptions) => [
        ...actualAllOptions,
        {
          value,
          label,
        },
      ]);
    }

    return () => {
      setAllOptions((actualAllOptions) => [..._remove(actualAllOptions, { value })]);
    };
  }, []);

  const selectedOptions = selectOthers ? [...allOptions.map((option) => option.value)] : [value];

  return (
    <DropdownItem
      data-qa-id={`search-dropdown-option-${value}`}
      onClick={() => {
        setSelectedOptions(selectedOptions);
        onChange({
          options: selectedOptions,
          inputValue,
        });
      }}
    >
      {label}
    </DropdownItem>
  );
};
